<template>
  <!--TableComponent.vue-->
  <table class="w-full table-fixed">
    <slot></slot>
  </table>
</template>
